module.exports = __webpack_public_path__ + "img/marker5.78c4f7ab.png";